import { campaignToTimelineFormatter, compareByRecentDate } from '../utils/helpers'

export function formatCampaignChart(data) {
  if (!data || data.campaigns.length === 0) return data
  const timelineTransformedData = campaignToTimelineFormatter(data.campaigns)
  return {
    ...data,
    campaigns: timelineTransformedData.sort(compareByRecentDate)
  }
}
